export const prodEnvironment = {
  coreUrl: 'https://offconon.com',
  workroomDomain: 'workroom.offconon.com',
  coreDomain: 'offconon.com',
  coreApi: 'https://coreapi.offconon.com',
  adminApi: 'https://adminapi.offconon.com',
  jitsiDomain: 'video.offconon.com',
  domainUrlSuffix: 'offconon.com',
  googleLoginProviderKey:
    '235695738921-kb6uhp4t8aq367tcmg5mcj4o5g7drdbq.apps.googleusercontent.com',
  recaptchaSiteKey: '6LfxyPwqAAAAAMnlq3S8UJJ4pCVp0_O1BcYNLuzK',
  stripePK:
    'pk_live_51IJzSSIE40gabAdffSsfi5AuePYpf8M0UhHLUSluIUoCGnOOzYOIhKVQODdF3CPpqMtildueHCOSLhs8HBHymZR100twGVdjHu',
  paypalClientId:
    'AV5b1-ydBzIMTSx1clS2p7xpHnyrJ0lucaQSjXlrGx77jcNspdH1tQbTXoxTE9BX1lLpx1-_u_XzICHw',
};
